import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=5b634d27&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"
import style0 from "../../../assets/styles/resource.scss?vue&type=style&index=0&id=5b634d27&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b634d27",
  null
  
)

export default component.exports